module.exports = __webpack_public_path__ + "static/media/HomePage-PromoBanner-text.3a0e0818.png";